import { Apis } from "../../../lib/Apis";

const unwrapResponseBody = (body) => {
  if (body == null) return null;
  if (body?.success === false) {
    throw new Error(body?.message || "Request failed.");
  }
  if (
    body &&
    typeof body === "object" &&
    "data" in body &&
    ("success" in body || "statusCode" in body)
  ) {
    return body.data;
  }
  return body;
};

const unwrapList = (body) => {
  const payload = unwrapResponseBody(body) ?? body ?? {};
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const popularCommercialArchitectureDesign = () => {
  const addPopularCommercialArchitectureDesign = async (data) => {
    try {
      const response = await Apis.addPopularCommercialArchitectureDesign(data);
      return unwrapResponseBody(response?.data) ?? response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAllCommercialArchitectureDesign = async (setCommercialArchitectureDesignNames) => {
    try {
      const response = await Apis.getAllCommercialArchitectureDesignNames();
      const items = unwrapList(response?.data);
      setCommercialArchitectureDesignNames(items);
      return items;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return {
    addPopularCommercialArchitectureDesign,
    getAllCommercialArchitectureDesign,
  };
};
